import { IIndustryTypeItem, IndustryType } from "./BrandTrust.types";

export const INDUSTRY_TYPE_CONFIG = [
  {
    index: 0,
    id: IndustryType.All,
    value: IndustryType.All,
    label: "landing.industryType.all",
  },
  {
    index: 1,
    id: IndustryType.Education,
    value: IndustryType.Education,
    label: "landing.industryType.education",
  },
  {
    index: 2,
    id: IndustryType.Hospitality,
    value: IndustryType.Hospitality,
    label: "landing.industryType.hospitality",
  },
  {
    index: 3,
    id: IndustryType.EnterpriseOffice,
    value: IndustryType.EnterpriseOffice,
    label: "landing.industryType.enterpriseOffice",
  },
  {
    index: 4,
    id: IndustryType.Retail,
    value: IndustryType.Retail,
    label: "landing.industryType.retail",
  },
  {
    index: 5,
    id: IndustryType.MissionCritical,
    value: IndustryType.MissionCritical,
    label: "landing.industryType.missionCritical",
  },
] satisfies IIndustryTypeItem[];

export const MOBILE_INDUSTRY_TYPE_CONFIG = [
  {
    index: 0,
    id: IndustryType.Education,
    value: IndustryType.Education,
    label: "landing.industryType.education",
  },
  {
    index: 1,
    id: IndustryType.Hospitality,
    value: IndustryType.Hospitality,
    label: "landing.industryType.hospitality",
  },
  {
    index: 2,
    id: IndustryType.EnterpriseOffice,
    value: IndustryType.EnterpriseOffice,
    label: "landing.industryType.enterpriseOffice",
  },
  {
    index: 3,
    id: IndustryType.Retail,
    value: IndustryType.Retail,
    label: "landing.industryType.retail",
  },
  {
    index: 4,
    id: IndustryType.MissionCritical,
    value: IndustryType.MissionCritical,
    label: "landing.industryType.missionCritical",
  },
] satisfies IIndustryTypeItem[];
